import React from 'react'
import { FloorLayerSectionProps } from './types'
import {
  PropertySection,
  SectionHeader,
  SectionTitle,
  CollapseIcon,
  SectionContent,
  PropertyGroup,
  Label,
  Select,
} from '../styled'
import { getUnitSingular } from '../helpers'

const FloorLayerSection: React.FC<FloorLayerSectionProps> = ({
  selectedElement,
  mapSettings,
  isCollapsed,
  onToggleSection,
  onUpdateElement,
}) => {
  return (
    <PropertySection>
      <SectionHeader isCollapsed={isCollapsed} onClick={onToggleSection}>
        <SectionTitle>Floor & Layer</SectionTitle>
        <CollapseIcon isCollapsed={isCollapsed}>▼</CollapseIcon>
      </SectionHeader>
      <SectionContent isCollapsed={isCollapsed}>
        <PropertyGroup>
          <Label>Floor Level</Label>
          <Select
            value={selectedElement.floor || mapSettings.currentFloor}
            onChange={e => {
              const floorId = Number(e.target.value)
              onUpdateElement(selectedElement.id, { floor: floorId })
            }}>
            {mapSettings.floors.map(floor => (
              <option key={floor.id} value={floor.id}>
                {floor.name} ({floor.elevation > 0 ? '+' : ''}
                {floor.elevation}
                {getUnitSingular(mapSettings)})
              </option>
            ))}
          </Select>
        </PropertyGroup>
      </SectionContent>
    </PropertySection>
  )
}

export { FloorLayerSection }
